import {
  BolusState,
  BolusType,
} from "@tandemdiabetes/sugarmate-api-react-client"
import styles from "./BolusEventModal.module.scss"

import type { BolusEventProps } from "./BolusEventProps"
import { usePolyglot } from "src/contexts"
import { serverInsulinToUserInsulin } from "src/utils"

export function BolusTypeValue(props: BolusEventProps) {
  const { userEvent } = props
  const polyglot = usePolyglot()

  if (!userEvent.bolus) {
    return null
  }

  return (
    <>
      <div className={styles.row}>
        <span className={`${styles.textLargeBold} ${styles.keyText}`}>
          {polyglot.t(
            `bolus_type.${userEvent.bolus.bolus_type ?? BolusType.Food}`,
          )}
        </span>
        <span className={styles.textLargeBold}>
          {polyglot.t(
            "unit.num_units_abbreviated",
            {
              units: serverInsulinToUserInsulin(
                userEvent.bolus.state === BolusState.InProgress
                  ? (userEvent.bolus.insulin_total_requested ?? userEvent.bolus.insulin_total_delivered ?? 0)
                  : (userEvent.bolus.insulin_total_delivered ?? 0),
              ).toLocaleString(
                polyglot.locale(),
              ),
            },
          )}
        </span>
      </div>
      <div className={styles.separator} />
    </>
  )
}
